import React from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { grey } from '@mui/material/colors';
import { Fonts } from 'constants/AppEnums';
import { initialUrl } from 'constants/AppConst';
import IntlMessages from '@tenant/utility/IntlMessages';
import { ReactComponent as Logo } from '../../../assets/icon/401.svg';
import { useTheme } from '@mui/material';
import { useAuthMethod } from '@tenant/utility/AuthHooks';
import PropTypes from 'prop-types';

const Error401 = ({ hideBtn = false, showSwitchToAccount = false }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { logout } = useAuthMethod();

  const onGoBackToHome = () => {
    navigate(initialUrl);
  };

  return (
    <Box>
      <Box
        sx={{
          py: { xl: 8 },
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            mb: { xs: 4, xl: 8 },
            width: '100%',
            maxWidth: { xs: 200, sm: 300, xl: 706 },
            '& svg': {
              width: '100%',
              maxWidth: 400,
            },
          }}
        >
          <Logo fill={theme.palette.primary.main} />
        </Box>
        <Box sx={{ mb: { xs: 4, xl: 5 } }}>
          <Box
            variant='h3'
            sx={{
              mb: { xs: 3, xl: 4 },
              fontSize: { xs: 20, md: 24 },
              fontWeight: Fonts.MEDIUM,
            }}
          >
            Unauthorized
          </Box>
          <Box
            sx={{
              mb: { xs: 4, xl: 5 },
              color: grey[600],
              fontSize: 16,
              fontWeight: Fonts.MEDIUM,
            }}
          >
            <Typography>
              You don't have permission to access this resource. Please contact
              your administrator for assistance.
            </Typography>
          </Box>
          {!hideBtn && (
            <Button
              variant='contained'
              color='primary'
              sx={{
                fontWeight: Fonts.MEDIUM,
                fontSize: 16,
                textTransform: 'capitalize',
              }}
              onClick={onGoBackToHome}
            >
              <IntlMessages id='error.goBackToHome' />
            </Button>
          )}
          {showSwitchToAccount && (
            <Button
              variant='contained'
              color='primary'
              sx={{
                fontWeight: Fonts.MEDIUM,
                fontSize: 16,
                textTransform: 'capitalize',
              }}
              onClick={logout}
            >
              Logout
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Error401;

Error401.propTypes = {
  hideBtn: PropTypes.bool,
  showSwitchToAccount: PropTypes.bool,
};
